export const AQ50 = 
{
    Metadata:{Name:'AQ-50',maxColumn:4,numRows:50},
    Sections:
    [
        {
            Headers:[
                "",
                "Definitely Agree",
                "Slightly Agree",
                "Slightly Disagree",
                "Definitely Disagree"
            ],
            Questions:[
                {
                    Prompt:"1. I prefer to do things with others rather than on my own.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. I prefer to do things the same way over and over again.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. If I try to imagine something, I find it very easy to create a picture in my mind.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. I frequently get so strongly absorbed in one thing that I lose sight of other things.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. I often notice small sounds when others do not.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. I usually notice car number plates or similar strings of information.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. Other people frequently tell me that what I've said is impolite, even though I think it is polite.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. When I'm reading a story, I can easily imagine what the characters might look like.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. I am fascinated by dates.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. In a social group, I can easily keep track of several different people's conversations.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"11. I find social situations easy.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"12. I tend to notice details that others do not.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"13. I would rather go to a library than to a party.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"14. I find making up stories easy.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"15. I find myself drawn more strongly to people than to things.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"16. I tend to have very strong interests, which I get upset about if I can't pursue.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"17. I enjoy social chitchat.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"18. When I talk, it isn't always easy for others to get a word in edgewise.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"19. I am fascinated by numbers.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"20. When I'm reading a story, I find it difficult to work out the characters' intentions.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"21. I don't particularly enjoy reading fiction.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"22. I find it hard to make new friends.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"23. I notice patterns in things all the time.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"24. I would rather go to the theater than to a museum.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"25. It does not upset me if my daily routine is disturbed.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"26. I frequently find that I don't know how to keep a conversation going.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"27. I find it easy to “read between the lines” when someone is talking to me.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"28. I usually concentrate more on the whole picture, rather than on the small details.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"29. I am not very good at remembering phone numbers.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"30. I don't usually notice small changes in a situation or a person's appearance.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"31. I know how to tell if someone listening to me is getting bored.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"32. I find it easy to do more than one thing at once.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"33. When I talk on the phone, I'm not sure when it's my turn to speak.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"34. I enjoy doing things spontaneously.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"35. I am often the last to understand the point of a joke.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"36. I find it easy to work out what someone is thinking or feeling just by looking at their face.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"37. If there is an interruption, I can switch back to what I was doing very quickly.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"38. I am good at social chitchat.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"39. People often tell me that I keep going on and on about the same thing.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"40. When I was young, I used to enjoy playing games involving pretending with other children.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"41. I like to collect information about categories of things (e.g., types of cars, birds, trains, plants).",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"42. I find it difficult to imagine what it would be like to be someone else.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"43. I like to carefully plan any activities I participate in.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"44. I enjoy social occasions.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"45. I find it difficult to work out people's intentions.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"46. New situations make me anxious.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"}
                    ]
                },
                {
                    Prompt:"47. I enjoy meeting new people.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"48. I am a good diplomat.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"49. I am not very good at remembering people's date of birth.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"50. I find it very easy to play games with children that involve pretending.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
            ]
        }
    ]
}